import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Label,
  Input,
  Button,
  FormFeedback,
} from 'reactstrap';
import {
  PROC_TYPE_OPTIONS,
  PROCUREMENT_TYPE_HEADER,
} from '../utils/awardingHelpers';

const PROCUREMENT_TYPE_CARDS = [
  {
    value: PROCUREMENT_TYPE_HEADER.productHydro,
    label: 'Product Hydro',
    icon: 'ri-gas-station-line',
  },
  {
    value: PROCUREMENT_TYPE_HEADER.hydroCondensate,
    label: 'Hydro & Condensate',
    icon: 'ri-oil-line',
  },
];

const INITIAL_FORM = {
  procurementNumber: '',
  procurementTypeHeader: PROCUREMENT_TYPE_HEADER.productHydro,
  titleProcurement: '',
  procurementType: '',
  description: '',
};

const CreateAwardingModal = ({
  isOpen,
  toggle,
  onNext,
  isSubmitting = false,
}) => {
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isOpen) {
      setForm(INITIAL_FORM);
      setErrors({});
    }
  }, [isOpen]);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const nextErrors = {};
    if (!form.procurementNumber.trim()) {
      nextErrors.procurementNumber = 'Number procurement is required';
    }
    if (!form.titleProcurement.trim()) {
      nextErrors.titleProcurement = 'Title procurement is required';
    }
    if (!form.procurementType) {
      nextErrors.procurementType = 'Proc type is required';
    }
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleNext = () => {
    if (!validate()) return;
    onNext({
      ...form,
      procurementNumber: form.procurementNumber.trim(),
      titleProcurement: form.titleProcurement.trim(),
      description: form.description.trim(),
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size='lg'>
      <ModalBody className='p-4'>
        <div className='d-flex justify-content-between align-items-start mb-1'>
          <h5 className='fw-bold mb-0'>Create New Awarding</h5>
          <button
            type='button'
            className='btn-close'
            onClick={toggle}
            aria-label='Close'
          ></button>
        </div>
        <p className='text-muted fs-13 mb-4'>
          Start a new awarding by filling in the details below.
        </p>

        <div className='mb-3'>
          <Label className='form-label fw-medium'>No Procurement</Label>
          <Input
            type='text'
            placeholder='Enter number procurement'
            value={form.procurementNumber}
            invalid={Boolean(errors.procurementNumber)}
            onChange={e => handleChange('procurementNumber', e.target.value)}
          />
          <FormFeedback>{errors.procurementNumber}</FormFeedback>
        </div>

        <div className='mb-3'>
          <Label className='form-label fw-medium'>Procurement Type</Label>
          <Row className='g-3'>
            {PROCUREMENT_TYPE_CARDS.map(card => {
              const isActive = form.procurementTypeHeader === card.value;
              return (
                <Col xs={12} md={6} key={card.value}>
                  <button
                    type='button'
                    className={`w-100 d-flex align-items-center justify-content-between border rounded p-3 bg-white shadow-none ${
                      isActive ? 'border-primary' : ''
                    }`}
                    onClick={() =>
                      handleChange('procurementTypeHeader', card.value)
                    }
                  >
                    <span className='d-flex align-items-center gap-2'>
                      <i
                        className={`${card.icon} fs-18 ${
                          isActive ? 'text-primary' : 'text-muted'
                        }`}
                      ></i>
                      <span className='fw-medium text-dark'>{card.label}</span>
                    </span>
                    <i
                      className={
                        isActive
                          ? 'ri-checkbox-circle-fill text-primary fs-18'
                          : 'ri-checkbox-blank-circle-line text-muted fs-18'
                      }
                    ></i>
                  </button>
                </Col>
              );
            })}
          </Row>
        </div>

        <Row className='g-3 mb-3'>
          <Col xs={12} md={6}>
            <Label className='form-label fw-medium'>Title Procurement</Label>
            <Input
              type='text'
              placeholder='Enter title procurement'
              value={form.titleProcurement}
              invalid={Boolean(errors.titleProcurement)}
              onChange={e => handleChange('titleProcurement', e.target.value)}
            />
            <FormFeedback>{errors.titleProcurement}</FormFeedback>
          </Col>
          <Col xs={12} md={6}>
            <Label className='form-label fw-medium'>Proc Type</Label>
            <Input
              type='select'
              value={form.procurementType}
              invalid={Boolean(errors.procurementType)}
              onChange={e => handleChange('procurementType', e.target.value)}
            >
              <option value=''>Please select</option>
              {PROC_TYPE_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
            <FormFeedback>{errors.procurementType}</FormFeedback>
          </Col>
        </Row>

        <div className='mb-4'>
          <Label className='form-label fw-medium'>Description</Label>
          <Input
            type='textarea'
            rows={4}
            placeholder='Enter description'
            value={form.description}
            onChange={e => handleChange('description', e.target.value)}
          />
        </div>

        <div className='d-flex justify-content-end align-items-center gap-2'>
          <Button
            color='link'
            className='text-decoration-none'
            onClick={toggle}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            color='primary'
            className='px-4'
            onClick={handleNext}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Next'}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CreateAwardingModal;
